import { useEffect, useState } from "react";
import Apply from "@/components/Apply";
import Footer from "@/components/Footer";
import ApplyModal from "@/components/ApplyModal";

const saasFlowPath = [
  {
    icon: "copperation_icon",
    title: "合作洽谈",
  },
  {
    icon: "verify_icon",
    title: "资质审核",
  },
  {
    icon: "contract_icon",
    title: "合同签约",
  },
  {
    icon: "system_icon",
    title: "系统对接",
  },
  {
    icon: "online_icon",
    title: "接单配送",
  },
];
// 加盟要求数据
const joinRequirements = [
  {
    id: "qualified",
    icon: "qualified_icon",
    hoverIcon: "qualified_hover_icon",
    title: "资质要求",
    description:
      "申请主体需为合法注册企业，持有营业执照及相关行业资质，无严重失信记录",
  },
  {
    id: "experience",
    icon: "experience_icon",
    hoverIcon: "experience_hover_icon",
    title: "运营经验",
    description:
      "具备3年以上即时配送行业运营经验，拥有成熟的业务管理和执行能力",
  },
  {
    id: "bankroll",
    icon: "bankroll_icon",
    hoverIcon: "bankroll_hover_icon",
    title: "资金实力",
    description: "企业注册资金不低于30万元，注册时间满1年以上，经营状况稳定",
  },
  {
    id: "systemAbility",
    icon: "system_ability_icon",
    hoverIcon: "system_ability_hover_icon",
    title: "系统能力",
    description:
      "拥有配送SaaS系统，骑手系统等核心功能，具备系统对接能力和系统并发处理能力",
  },
];

const ServiceBusiness = () => {
  const [showModal, setShowModal] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0); // 跳转后滚动到顶部
  }, []);

  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <div className="service_business_wrapper">
      <ApplyModal isShow={showModal} onCancel={onCancel} />
      <div className="carousel_wrapper_front">
        <img
          style={{ width: "100%" }}
          src={`https://static.hiboos.com/static/yzt-home/homePage/delivery_join.webp`}
          alt=""
        />
        <div className="opt_btn_wrapper">
          <div
            className="opt_btn"
            onClick={() => {
              window.open("https://www.wjx.cn/vm/O8p2iCA.aspx#", "_blank");
              setDjMs("func_service_cooperate-web", "配送商入驻");
            }}
          >
            点击合作
          </div>
        </div>
      </div>
      <div className="saas_flow_path">
        <p className="title_big">配送服务商加盟入驻流程</p>
        <div className="card_wrapper">
          {saasFlowPath.map((item, index) => {
            return (
              <div key={index} className="card_item">
                <div className="card">
                  <img
                    className="icon"
                    src={`https://static.hiboos.com/static/yzt-home/hiboTian/${item.icon}.png`}
                    alt=""
                  />
                  <p className="title">{item.title}</p>
                </div>
                <img
                  className="right_arrow"
                  width={19}
                  height={76}
                  src={`https://static.hiboos.com/static/yzt-home/hiboTian/right_arrow.png`}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* 配送商合作优势 */}
      <div className="product_points">
        <img
          height={644}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/cooperate_advantage.png`}
          alt=""
        />
      </div>
      {/* 京东订单无缝直发 */}
      <div className="delivery_brand">
        <img
          height={524}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/jdorder_send.png`}
          alt=""
        />
      </div>
      {/* 配送商全方位扶持 */}
      <div className="Rx">
        <img
          height={524}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/delivery_support.png`}
          alt=""
        />
      </div>
      {/* 配送服务商加盟要求 */}
      <div className="join_demand">
        <p className="title_big">配送服务商加盟要求</p>
        <div className="card_wrapper">
          {joinRequirements.map((item) => (
            <div
              key={item.id}
              className="card_item card_item_left"
              onMouseEnter={() => setHoveredCard(item.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <img
                height={50}
                src={`https://static.hiboos.com/static/yzt-home/hiboTian/${
                  hoveredCard === item.id ? item.hoverIcon : item.icon
                }.png`}
                alt=""
              />
              <div className="content_wrapper">
                <p className="title">{item.title}</p>
                <p className="text">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="cooperative_channel">
        <p className="title_big" style={{ marginBottom: "40px" }}>
          合作的商流渠道
        </p>
        <img
          height={229}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/cooperate_channel.png`}
          alt=""
        />
      </div>
      <Apply />
      <Footer />
    </div>
  );
};
export default ServiceBusiness;
